import { Button } from 'react-bootstrap';
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import classes from './LogoutModal.module.scss';
import { resetAppStore } from 'utils/utils';
import { useNavigate } from 'react-router-dom';

const LogoutModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //clearing the store on logout
  useEffect(() => {
    resetAppStore(dispatch);
  }, []);

  return (
    <div className={`d-flex flex-column align-items-center bg-white`}>
      <i className='icon icon__logo animate__animated animate__rubberBand'></i>
      <div className='divider-horizontal divider__grey w-50 mt-1'></div>
      <div className={`${classes.messageContainer} mt-4 w-50`}>
        <p
          className={`${classes.subMessage} text__grey title__bold title__medium`}>
          You have been logged out.
        </p>
        <p className={`${classes.sessionMessage} mt-4 mb-4`}>
          Your session has expired. Click "Log in" to redirect to the login
          page.
        </p>
        <Button
          variant={`outline-primary w-25 btn-gne btn-gne__outline float-right`}
          onClick={() => {
            navigate('/home');
          }}>
          <span>Log in</span>
        </Button>
      </div>
    </div>
  );
};

export default LogoutModal;
